import React from 'react';

const GenericFlowExport = ({datasets, sheetName, flow}) => {
    return (
        <table className="d-none export-all" id={sheetName}>
            <thead>
            <tr>
                <th>Sentido</th>
                <th>Fluxo veicular</th>
                <th>{sheetName === "day-export" ? 'Dia' : 'Hora'}</th>
                <th>Quantidade</th>
            </tr>
            </thead>
            <tbody>
            {datasets.map((dataset, datasetIndex) => {
                return dataset.data.map((item, rowIndex) => {
                    return (
                        <tr key={`dataset-${datasetIndex}-row-${rowIndex}`}>
                            <td>{dataset.title}</td>
                            <td>{flow}</td>
                            <td>{sheetName === "day-export" ? item.day : item.time}</td>
                            <td>{item.qty}</td>
                        </tr>
                    );
                });
            })}
            </tbody>
        </table>
    );
};

export default GenericFlowExport;